module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Media/Forward-e49c3ee09c89e718a4eb4bfa8875b0c5a7ea6621bfb1bdc47e6f15ca6d328d81.svg";